import { BASE_URL,  POLICIES, QUESTIONS } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { ApiResponse } from "./auth";
import { IQuestion, IQuestionInput } from "models/question";


export async function getQuestions(params: string = "") : Promise<ApiResponse<IQuestion[]>> {
  const response = await axios.get(BASE_URL + QUESTIONS + params);
  return response.data;
}


export async function addQuestion(data: FormData) {
  const response = await axios.post(BASE_URL + QUESTIONS, data,{
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	});
  return response.data;
}
export async function editQuestion(data: FormData, id: string) {
  const response = await axios.patch(BASE_URL + QUESTIONS + `\\${id}` , data ,{
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	});
  return response.data;
}

export async function deleteQuestion(id: string) {
  const response = await axios.delete(BASE_URL + QUESTIONS + `\\${id}`);
  return response.data;
}


export const QuestionCells: HeadCell[] = [
  {
    id: "questionText",
    numeric: false,
    disablePadding: false,
    label: "Text",
    
  },
  {
    id: "questionDescription",
    numeric: false,
    disablePadding: false,
    label: "Description",
    
  },
  // {
  //   id: "isActive",
  //   numeric: false,
  //   disablePadding: false,
  //   label: "is Active",
    
  // },
  {
    id: "questionImagePath",
    numeric: false,
    disablePadding: false,
    label: "Image",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "Actions",
  },
];